import { type GroupByField } from '~domains/commerce/dashboard/entities/summary';

import { MoneyPh } from '~shared/ui/money-ph';

import { createColumnHelper } from '@tanstack/react-table';

import type { SummaryTableData } from '../model/summary-table-data';

const columnHelper = createColumnHelper<SummaryTableData>();

export enum ColumnId {
  MERCHANT_NAME = 'merchantName',
  POS_NAME = 'posName',
  LOANS_AMOUNT = 'loansAmount',
  SALES_AMOUNT = 'salesAmount',
  LOANS_COUNT = 'loansCount',
}

type ColumnOption = { id: ColumnId; label: string };

export const ALL_COLUMN_IDS: ColumnId[] = [
  ColumnId.MERCHANT_NAME,
  ColumnId.POS_NAME,
  ColumnId.LOANS_COUNT,
  ColumnId.LOANS_AMOUNT,
  ColumnId.SALES_AMOUNT,
];

export const SORT_OPTIONS: ColumnOption[] = [
  { id: ColumnId.LOANS_COUNT, label: 'Number of loans' },
  { id: ColumnId.LOANS_AMOUNT, label: 'Loans amount' },
  { id: ColumnId.SALES_AMOUNT, label: 'Sales amount' },
];

export const getColumnOptions = (groupBy: GroupByField): ColumnOption[] => [
  { id: ColumnId.MERCHANT_NAME, label: 'Business' },
  ...(groupBy === 'by-pos' ? [{ id: ColumnId.POS_NAME, label: 'Store' }] : []),
  { id: ColumnId.LOANS_COUNT, label: 'Number of loans' },
  { id: ColumnId.LOANS_AMOUNT, label: 'Loans amount' },
  { id: ColumnId.SALES_AMOUNT, label: 'Sales amount' },
];

export const getColumns = (groupBy: GroupByField) => [
  columnHelper.accessor((row) => row.merchantName, {
    id: ColumnId.MERCHANT_NAME,
    meta: { minWidth: 160 },
    cell: (data) => data.getValue(),
    header: () => <span>Business</span>,
  }),
  ...(groupBy === 'by-merchant'
    ? []
    : [
        columnHelper.accessor((row) => row.posName, {
          id: ColumnId.POS_NAME,
          meta: { minWidth: 160 },
          cell: (data) => data.getValue(),
          header: () => <span>Store</span>,
        }),
      ]),
  columnHelper.accessor((row) => row.loansCount, {
    id: ColumnId.LOANS_COUNT,
    meta: { width: 160, align: 'right', sortable: true },
    cell: (data) => data.getValue(),
    header: () => <span>Number of loans</span>,
  }),
  columnHelper.accessor((row) => row.loansAmount, {
    id: ColumnId.LOANS_AMOUNT,
    meta: { width: 240, align: 'right', sortable: true },
    cell: (data) => <MoneyPh value={data.getValue()} />,
    header: () => <span>Loans amount</span>,
  }),
  columnHelper.accessor((row) => row.salesAmount, {
    id: ColumnId.SALES_AMOUNT,
    meta: { width: 240, align: 'right', sortable: true },
    cell: (data) => <MoneyPh value={data.getValue()} />,
    header: () => <span>Sales amount</span>,
  }),
];
